import React, { useEffect, useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { applyActionCode } from 'firebase/auth';
import { doc, setDoc } from 'firebase/firestore';
import { firebaseAuth, firestore } from '../firebase';
import LoadingBox from '../Components/LoadingBox';
import MessageBox from '../Components/MessageBox';

export default function VerifyEmailScreen() {
  const location = useLocation();
  const history = useHistory();
  const [status, setStatus] = useState({ loading: true, success: false, message: '' });

  useEffect(() => {
    const params = new URLSearchParams(location.search || '');
    const oobCode = params.get('oobCode');

    async function verify() {
      if (!oobCode) {
        setStatus({ loading: false, success: false, message: 'Missing verification code.' });
        return;
      }
      try {
        await applyActionCode(firebaseAuth, oobCode);

        // Determine UID to update
        let uid = params.get('uid');
        if (!uid && firebaseAuth.currentUser) {
          uid = firebaseAuth.currentUser.uid;
        }

        // Update Firestore flag
        if (uid) {
          try {
            await setDoc(
              doc(firestore, 'USERS', uid),
              { Email_Verified: true },
              { merge: true }
            );
          } catch (e) {
            // Non-fatal: proceed even if Firestore update fails
            console.warn('Failed to update Email_Verified flag:', e);
          }

          // Update cached userInfo if present
          try {
            const raw = localStorage.getItem('userInfo');
            if (raw) {
              const info = JSON.parse(raw);
              if (info && info.uid === uid) {
                localStorage.setItem('userInfo', JSON.stringify({ ...info, emailVerified: true }));
              }
            }
          } catch (_) {}
        }

        setStatus({ loading: false, success: true, message: 'Email verified successfully.' });
        // Redirect after a brief delay
        setTimeout(() => history.replace('/signin'), 5000);
      } catch (err) {
        const msg = err?.message || 'Verification failed. The link may be invalid or expired.';
        setStatus({ loading: false, success: false, message: msg });
      }
    }

    verify();
  }, [location.search, history]);

  if (status.loading) return <LoadingBox />;

  return (
    <div style={{ maxWidth: 500, margin: '40px auto' }}>
      {status.success ? (
        <MessageBox variant="success">{status.message} Redirecting to Sign In…</MessageBox>
      ) : (
        <MessageBox variant="danger">{status.message}</MessageBox>
      )}
    </div>
  );
}
